/* 🤖 this file was generated by svg-to-ts */
export const emperorIconArrangeAToZ: {
  name: 'arrange_a_to_z';
  data: string;
} = {
  name: 'arrange_a_to_z',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M20 2h-4c-.56 0-1 .44-1 1v7h2V8h2v2h2V3c0-.56-.45-1-1-1Zm-3 4V4h2v2h-2Z"/><path d="M20.832 15.55c.2-.31.22-.71.05-1.03 -.18-.33-.52-.53-.89-.53h-5v2h3.13l-2.97 4.445c-.21.3-.23.7-.05 1.02 .17.32.51.52.88.52h5v-2h-3.14l2.96-4.45Z"/><path d="M9 17.586L9 2.99l-2 0 0 14.58 -2.293-2.3 -1.42 1.41 4.707 4.7 4.7-4.71 -1.42-1.42Z"/></g></svg>`
};
